import * as React from 'react';
import { SVGProps } from 'react';

const IconShuffleSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.29 5.87 3.41 2 2 3.41l3.87 3.87 1.42-1.41zM9.5 2l1.54 1.54L2 12.59 3.41 14l9.05-9.04L14 6.5V2H9.5zm.63 6.71-1.41 1.41 2.33 2.33L9.5 14H14V9.5l-1.54 1.54-2.33-2.33z" />
  </svg>
);
export default IconShuffleSizeS;
